module.exports = __webpack_public_path__ + "static/media/l12_voice_twelve_v2.3bead810.mp3";